// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPageView_container__TeT9b","content":"NotFoundPageView_content__E3+dp","links":"NotFoundPageView_links__QFZ72"};